"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _excluded = ["className", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "dialog": "t76h6M"
};
var Dialog = function Dialog(_ref) {
  var className = _ref.className,
    onEnter = _ref.onEnter,
    onEntered = _ref.onEntered,
    onEntering = _ref.onEntering,
    onExit = _ref.onExit,
    onExited = _ref.onExited,
    onExiting = _ref.onExiting,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], _extends({
    className: (0, _clsx["default"])(className, styles.dialog)
    // Adapter for mui v5
    ,

    TransitionProps: {
      onEnter: onEnter,
      onEntered: onEntered,
      onEntering: onEntering,
      onExit: onExit,
      onExited: onExited,
      onExiting: onExiting
    }
  }, props));
};
Dialog.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  onEnter: _propTypes["default"].func,
  onEntered: _propTypes["default"].func,
  onEntering: _propTypes["default"].func,
  onExit: _propTypes["default"].func,
  onExited: _propTypes["default"].func,
  onExiting: _propTypes["default"].func
} : {};
var _default = exports["default"] = Dialog;